import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  defineBlock,
  smartProps,
  BlockWrapper,
  useEditor,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import clsx from "clsx";
import he from "he";
import { lazy } from "react";
import style from "./style.module.scss";

const Inspector = lazy(() => import("./inspector.js"));

export const Breadcrumb = ({ breadcrumb, ...props }) => {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();

  if (!isEditing && !breadcrumb) return null;

  return (
    <BlockWrapper.Ul className={clsx(style.breadcrumb, props.className)}>
      {breadcrumb &&
        breadcrumb.map((item, key) =>
          item ? (
            <li key={key} className={style.item}>
              {item?.disable ? (
                <p>{he.decode(item.label)}</p>
              ) : (
                <a href={item.url}>{he.decode(item.label)}</a>
              )}
              {breadcrumb.length > key + 1 && (
                <ChevronRightIcon className={style.arrow} />
              )}
            </li>
          ) : null
        )}
    </BlockWrapper.Ul>
  );
};

export default defineBlock({
  Block: Breadcrumb,
  setup: {
    title: "Breadcrumb",
  },
  smartProps: {
    breadcrumb: smartProps.array.withDefault([
      {
        label: "Item 1",
        pageId: "0",
        url: "#",
      },
      {
        label: "Item 2",
        pageId: "0",
        url: "#",
      },
    ]),
  },
});
